// client/src/components/Register.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AppBarHeader from './AppBarHeader';
import axiosInstance from '../axiosInstance';

function CreateAccount() {
  const [userData, setUserData] = useState({ username: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  // The handleInputChange function handles the input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  // The handleSubmit function handles form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents the default form submit action
    try {
      console.log('Attempting to create account:', { username: userData.username, email: userData.email });
      const response = await axiosInstance.post('/auth/register', userData);
      console.log('Account creation response:', response.data);

      setSuccess(true);
    } catch (error) {
      console.error('Error creating account:', error.response?.data || error.message);
      if (error.response?.status === 429) {
        setError('Too many registration attempts. Please wait 15 minutes and try again.');
      } else if (error.response?.data?.error) {
        setError(`Failed to create account: ${error.response.data.error}`);
      } else {
        setError('An error occurred during account creation.');
      }
    }
  };

  return (
    <div>
      <Helmet>
        <title>Create Account — InterCollect</title>
      </Helmet>
      <AppBarHeader />
      <Box sx={{ maxWidth: 600, margin: '0 auto', padding: '20px', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Create New Account</Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Account created! Please check your email to verify your address before logging in. If you don't see it within a few minutes, check your spam or junk folder.
          </Alert>
        )}
        {!success && (
          <form onSubmit={handleSubmit}>
            <Box sx={{ mb: 3 }}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                variant="outlined"
                value={userData.username}
                onChange={handleInputChange}
                required
              />
            </Box>
            <Box sx={{ mb: 3 }}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                variant="outlined"
                type="email"
                value={userData.email}
                onChange={handleInputChange}
                required
              />
            </Box>
            <Box sx={{ mb: 3 }}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                variant="outlined"
                type="password"
                value={userData.password}
                onChange={handleInputChange}
                required
              />
            </Box>
            <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
              Create Account
            </Button>
          </form>
        )}
        {success && (
          <Box sx={{ mt: 2 }}>
            <Button component={Link} to="/login" variant="contained">Go to Login</Button>
          </Box>
        )}
      </Box>
    </div>
  );
}

export default CreateAccount;
